import React from 'react';
import styled from 'styled-components';
import { Grid, Type } from '../../../app/StyleGuide';
import { FullWidthCard } from '../../../components/Layout';
import { PrimaryButton, SmallRoundedIconButton } from '../../../components/Buttons';
import windowService from '../../../services/windowService';

const ViewAllTrainingContainer = styled(FullWidthCard)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: ${Type.Color.dark};
  background-repeat: repeat-x;
  background-position-x: center;
  background-position-y: calc(100% - 45px);
  margin-bottom: 0;
  > i {
    color: ${Type.Color.medium};
    font-size: ${Type.Scale._8};
  }
  > button {
    margin-top: ${Grid._8};
  }
  h3 button {
    display: inline;
    margin-left: ${Grid._3};
  }
`;

export default function ViewAllTraining({
  description,
  onEditClick,
}: {
  description: string;
  onEditClick?: () => void;
}) {
  return (
    <ViewAllTrainingContainer>
      <i className="fas fa-book-open"></i>
      <h3>
        {description}
        {onEditClick && !description && <PrimaryButton onClick={onEditClick}>Add Text Header</PrimaryButton>}
        {onEditClick && description && (
          <SmallRoundedIconButton onClick={onEditClick}>
            <i className="fas fa-pen" />
          </SmallRoundedIconButton>
        )}
      </h3>
      <PrimaryButton onClick={() => windowService.redirectTo('#/search')} disabled={!!onEditClick}>
        View All Training
      </PrimaryButton>
    </ViewAllTrainingContainer>
  );
}
